import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchPin, clearPinData } from 'lib/actions';
import {
    getCardsIsFetchingPin,
    getCardsPin,
    getCardsPinError,
} from 'lib/selectors';
import { useForm, usePrevious } from 'lib/utils';
import { CARDS_PIN_OPTIONS } from 'constants/shared/routes';
import EnterCVCModal from '../presentational/EnterCVCModal';

const EnterCVCModalContainer = ({ hideModal, cardSerial }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const pin = useSelector(getCardsPin);
    const isFetching = useSelector(getCardsIsFetchingPin);
    const error = useSelector(getCardsPinError);
    const [form, handleChange] = useForm({
        cvc: '',
    });

    const handleSubmit = () => {
        const { cvc } = form;

        dispatch(fetchPin(cardSerial, cvc));
    };

    const prevPin = usePrevious(pin);

    useEffect(() => {
        if (!prevPin && pin) {
            navigate(CARDS_PIN_OPTIONS, { state: { authCVC: true, pin: pin }});
            dispatch(hideModal());
        }
    }, [pin, dispatch, navigate, hideModal, prevPin]);

    useEffect(() => {
        dispatch(clearPinData());

        return () => {
            dispatch(clearPinData());
        };
    }, [dispatch]);

    return (
        <EnterCVCModal
            {...form}
            error={error}
            isPosting={isFetching}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
        />
    );
};

export default EnterCVCModalContainer;
